/**
 * @author Madhu.Sudhan
 * @Date: 2023-04-26 13:05:13
 * @Last Modified by: madhusudhan
 * @Last Modified time: 2023-04-26 13:14:33
 */

import { createSelector } from 'reselect';
import { immutableToJS } from '../../devUtils/commonUtils';

const selectYscTransactionLimitsDomain = (state) => state.get('yscTransactionLimits');
const selectYscTransactionLimits = () => createSelector(
  selectYscTransactionLimitsDomain,
  (YscTransactionLimits) => YscTransactionLimits,
);

const fetchYscTransaction = () => createSelector(
  selectYscTransactionLimitsDomain,
  (YscTransactionLimits) => immutableToJS(YscTransactionLimits.get('fetchYscTransactionLimits')),
);

const updateYscTransaction = () => createSelector(
  selectYscTransactionLimitsDomain,
  (YscTransactionLimits) => immutableToJS(YscTransactionLimits.get('updateYscTransactionLimits')),
);

const isTransactionLimitsLoading = () => createSelector(
  selectYscTransactionLimitsDomain,
  (YscTransactionLimits) => YscTransactionLimits.get('isLoading'));

export { selectYscTransactionLimits, fetchYscTransaction, updateYscTransaction, isTransactionLimitsLoading };



// WEBPACK FOOTER //
// client/containers/YscTransactionLimits/selectors.js